const rankingList = [
  {
    path: "/ranking",
    label: "Rankings Home",
    description:
      "Get a glimpse into the top and trending titles across all titles in Pantheon",
    parent: "ranking",
  },
  {
    path: "/ranking/movies",
    label: "Movies",
    description:
      "View rankings of all movies based on metrics that span across most titles",
    parent: "ranking",
  },
  {
    path: "/ranking/series",
    label: "Series",
    description:
      "View rankings of all series based on metrics that span across most titles",
    parent: "ranking",
  },
  {
    path: "/ranking/games",
    label: "Games",
    description:
      "View rankings of all games based on metrics that span across most titles",
    parent: "ranking",
  },
  {
    path: "/ranking/books",
    label: "Books",
    description:
      "View rankings of all books based on metrics that span across most titles",
    parent: "ranking",
  },
  {
    path: "/ranking/anime",
    label: "Anime",
    description:
      "View rankings of all anime based on metrics that span across most titles",
    parent: "ranking",
  },
  {
    path: "/ranking/manga",
    label: "Manga",
    description:
      "View rankings of all manga based on metrics that span across most titles",
    parent: "ranking",
  },
  {
    path: "/ranking/franchises",
    label: "Franchises",
    description:
      "View rankings of all franchises based on metrics that span across most franchises and their titles",
    parent: "ranking",
  },
  {
    path: "/ranking/series-originals",
    label: "Series Originals",
    description: "View rankings of series originals by streaming platform",
    parent: "ranking",
  },
  {
    path: "/ranking/by-collection",
    label: "By Collection",
    description:
      "View relative rankings of items within a collection based on an extended set of platform metrics",
    parent: "ranking",
  },
];

const dashboardList = [
  {
    path: "/dashboards/wizard",
    label: "Personal Dashboard",
    description:
      "Customizable page view populated from a library of data widgets",
    parent: "dashboards",
  },
  // {
  //   path: "/dashboards/netflix",
  //   label: "Netflix Dashboard",
  //   description: "Based on public data from Netflix",
  //   parent: "dashboards",
  // },
  //{
  //  path: "/dashboards/nonott",
  //  label: "Non-OTT Titles",
  //  description: "Titles beyond OTT platforms",
  //  parent: "dashboards",
  //},
  {
    path: "/dashboards/news",
    label: "News River",
    description:
      "Stream of news articles from hand-picked sources related to entertainment",
    parent: "dashboards",
  },
  {
    path: "/dashboards/genres",
    label: "Genre Dashboard",
    description:
      "View top genres and sub-genres across verticals and timeframes, as well as the titles driving them",
    parent: "dashboards",
  },
  {
    path: "/box-office",
    label: "Box Office Analysis",
    description:
      "Comprehensive box office performance analysis and financial performance of films across various markets",
    parent: "tools",
  },
  {
    path: "/dashboards/jwstreaming",
    label: "JustWatch Charts",
    description: "Streaming charts based on user activity on JustWatch",
    parent: "tools",
  },
  {
    path: "/tools/streaming-window",
    label: "Streaming Window",
    description: "See how long titles are available on streaming platforms",
    parent: "tools",
  },
  {
    path: "/dashboards/top_lists/webtoons",
    label: "Top Lists",
    description: "A collection of top charts for various different media",
    parent: "tools",
  },
];

const platformsList = [
  /*{
    path: "/platforms/global",
    label: "Pantheon",
    description: "Ranked list of titles with summary metrics built on data from all platforms using default category weights",
    parent: "platforms",
  },*/
  {
    path: "/platforms/wikipedia",
    label: "Wikipedia",
    description: "Rankings and insights for Wikipedia",
    parent: "platforms",
  },
  {
    path: "/platforms/google",
    label: "Google",
    description: "Google search trends",
    parent: "platforms",
  },
  {
    path: "/platforms/imdb",
    label: "IMDb",
    description: "Rankings and insights for IMDb",
    parent: "platforms",
  },
  {
    path: "/platforms/rottentomatoes",
    label: "Rotten Tomatoes",
    description: "Rankings and insights for Rotten Tomatoes",
    parent: "platforms",
  },
  {
    path: "/platforms/twitch",
    label: "Twitch",
    description: "Rankings and insights for Twitch",
    parent: "platforms",
  },
  {
    path: "/platforms/steam",
    label: "Steam",
    description: "Rankings and insights for Steam",
    parent: "platforms",
  },
  {
    path: "/platforms/youtube",
    label: "YouTube",
    description: "Rankings and insights for YouTube",
    parent: "platforms",
  },
  {
    path: "/platforms/piracy",
    label: "Piracy",
    description: "Rankings and insights for piracy",
    parent: "platforms",
  },
  {
    path: "/platforms/twitter",
    label: "X (Twitter)",
    description: "Rankings and insights for X (Twitter)",
    parent: "platforms",
  },
  {
    path: "/platforms/tiktok",
    label: "TikTok",
    description: "Rankings and insights for TikTok",
    parent: "platforms",
  },
  {
    path: "/platforms/reddit",
    label: "Reddit",
    description: "Rankings and insights for Reddit",
    parent: "platforms",
  },
  {
    path: "/platforms/ao3",
    label: "AO3",
    description: "Rankings and insights for AO3",
    parent: "platforms",
  },
  {
    path: "/platforms/wattpad",
    label: "Wattpad",
    description: "Rankings and insights for Wattpad",
    parent: "platforms",
  },
  {
    path: "/platforms/fandom",
    label: "Fandom",
    description: "Rankings and insights for Fandom",
    parent: "platforms",
  },
  {
    path: "/platforms/amazonbooks",
    label: "Amazon Books",
    description: "Rankings and insights for Amazon Books",
    parent: "platforms",
  },
  {
    path: "/platforms/barnesnoble",
    label: "Barnes & Noble",
    description: "Rankings and insights for Barnes & Noble",
    parent: "platforms",
  },
  {
    path: "/platforms/goodreads",
    label: "Goodreads",
    description: "Rankings and insights for Goodreads",
    parent: "platforms",
  },
  {
    path: "/platforms/fablebooks",
    label: "Fable Books",
    description: "Rankings and insights for Fable Books",
    parent: "platforms",
  },
  {
    path: "/platforms/storygraph",
    label: "StoryGraph",
    description: "Rankings and insights for StoryGraph",
    parent: "platforms",
  },
  {
    path: "/platforms/myanimelist",
    label: "MyAnimeList",
    description: "Rankings and insights for MyAnimeList",
    parent: "platforms",
  },
  {
    path: "/platforms/anilist",
    label: "AniList",
    description: "Rankings and insights for AniList",
    parent: "platforms",
  },
];

const accountManagementList = [
  {
    path: "/users",
    label: "Users",
    description: "Manage users and their passwords",
    parent: "account-management",
  },
  {
    path: "/roles",
    label: "Roles",
    description: "Manage roles and their permissions",
    parent: "account-management",
  },
  {
    path: "/permissions",
    label: "Permissions",
    description: "Manage permissions",
    parent: "account-management",
  },
  {
    path: "/teams",
    label: "Teams",
    description: "Manage teams and their members",
    parent: "account-management",
  },
];

const topicModellingList = [
  {
    path: "/topic-modeling/pantheon",
    label: "General",
    description:
      "General topics leveraging clustered data sets from YouTube and Reddit",
    parent: "topic-modeling",
  },
  {
    path: "/topic-modeling/true-crime",
    label: "True Crime",
    description:
      "True crime topics leveraging clustered data sets from YouTube and Reddit",
    parent: "topic-modeling",
  },
];

const toolsList = [
  {
    path: "/tools/compare",
    label: "Compare",
    description:
      "Compare the performance of titles over time across multiple datapoints",
    parent: "tools",
  },
  /*{
    "path": "/tools/google-search-trends",
    "label": "Google Search Trends",
    "description": "Explore real-time search data from Google Trends with more room for comparison",
    "parent": "tools"
  },*/
  {
    path: "/tools/twitter-query-trends",
    label: "Twitter Query Trends",
    description:
      "Track and analyze real-time and historical query trends on Twitter",
    parent: "tools",
  },
  {
    path: "/tools/report-builder",
    label: "Report Builder",
    description:
      "Generate exportable reports based on data within Pantheon for any number of titles",
    parent: "tools",
  },
];

const exploreList = [
  {
    path: "/explore/movies",
    label: "Movies",
    description: "Search for movies in Pantheon",
    parent: "explore",
  },
  {
    path: "/explore/television",
    label: "Series",
    description: "Search for series in Pantheon",
    parent: "explore",
  },
  {
    path: "/explore/games",
    label: "Games",
    description: "Search for games in Pantheon",
    parent: "explore",
  },
  {
    path: "/explore/books",
    label: "Books",
    description: "Search for books in Pantheon",
    parent: "explore",
  },
  {
    path: "/explore/anime",
    label: "Anime",
    description: "Search for anime in Pantheon",
    parent: "explore",
  },
  {
    path: "/explore/manga",
    label: "Manga",
    description: "Search for manga in Pantheon",
    parent: "explore",
  },
  {
    path: "/explore/talent",
    label: "Talent",
    description: "Search for talent in Pantheon",
    parent: "explore",
  },
  {
    path: "/explore/franchise",
    label: "Franchises",
    description: "Search for franchises in Pantheon",
    parent: "explore",
  },
  {
    path: "/explore/companies",
    label: "Companies",
    description:
      "Search for studios, distributors, developers and publishers in Pantheon",
    parent: "explore",
  },
  {
    path: "/explore/collections",
    label: "Collections",
    description: "Search for collections in Pantheon",
    parent: "explore",
  },
];

// Same order as the YouTube side navigation: the overview, then Creator
// Discovery, then Trailers, then the two standalone pages. A label has to read
// on its own here, because a favourited item is shown without its group.
const youtubeList = [
  {
    path: "/youtube",
    label: "YouTube Overview",
    description:
      "One screen covering creators, their titles, trailers, categories and channels",
    parent: "youtube",
  },
  {
    path: "/youtube/discovery",
    label: "Creator Discovery",
    description:
      "Creators we found on YouTube, how fast they are growing, and what they have made",
    parent: "youtube",
    isNew: true,
  },
  {
    path: "/youtube/discovery/creators",
    label: "Creators",
    description: "Every creator we found, ranked by score and filterable",
    parent: "youtube",
    isNew: true,
  },
  {
    path: "/youtube/discovery/content",
    label: "Content",
    description:
      "Series, films and recurring formats that creators have made",
    parent: "youtube",
    isNew: true,
  },
  {
    path: "/youtube/trailers",
    label: "Trailers",
    description: "Official trailers, and which ones are being watched today",
    parent: "youtube",
  },
  {
    path: "/youtube/trailers/list",
    label: "All Trailers",
    description: "Every trailer, filtered by category and audience",
    parent: "youtube",
  },
  {
    path: "/youtube/trailers/unmapped",
    label: "Unmapped Trailers",
    description: "Trailers with no title attached yet",
    parent: "youtube",
  },
  {
    path: "/youtube/trends",
    label: "Popular Categories",
    description: "Which YouTube video categories are doing well",
    parent: "youtube",
    isUpdated: true,
  },
  {
    path: "/youtube/channels",
    label: "Tracked Channels",
    description: "Channels we follow by hand, measured every day",
    parent: "youtube",
  },
];

export const servicesList = [
  { key: "favorites", label: "Favorites" },
  { key: "ranking", label: "Rankings", items: rankingList },
  { key: "dashboards", label: "Dashboards", items: dashboardList },
  { key: "platforms", label: "Platforms", items: platformsList },
  /*{
    key: "topicModelling",
    label: "Topic Modeling",
    items: topicModellingList,
  },*/
  { key: "tools", label: "Tools", items: toolsList },
  {
    key: "explore",
    label: "Explore",
    items: exploreList,
  },
  {
    key: "youtube",
    label: "YouTube",
    items: youtubeList,
    isUpdated: true,
  },
  {
    key: "pulse",
    label: "Pantheon Pulse",
    path: "/pulse",
    isNew: false,
  },
  {
    key: "account-management",
    label: "Account Management",
    items: accountManagementList,
  },
];
